import { IPermissionsInitialState } from '@types';

export const initialPermissions = (): IPermissionsInitialState => {
    return { permissionsList: { total: 0, permissions: [] } };
};
